module.exports = __webpack_public_path__ + "static/media/TH2.ea8c0762.jpg";